<template>
  <div id="issueDetailPage">
    <div class="header">
      <div class="title">
        <i class="icon icon-wen"></i>
        <span class="name">{{detail.name}}</span>
      </div>
      <div class="tags">
        <router-link :to="{name: 'CircleDetail', query:{ id: detail.circle.id } }" class="item" v-if="detail.circle">
          <img class="icon" :src="require('@/assets/images/issue/icon_issue_02.png')" />
          <span>{{detail.circle.name}}</span>
        </router-link>
      </div>
    </div>
    <div class="section">
      <div class="user" v-if="detail.user">
        <van-image
          class="avatar"
          :src="detail.user.avatar"
          fit="cover"
          round
        ></van-image>
        <div class="info">
          <div class="name text-ellipsis">{{detail.user.name}}</div>
          <div class="date">{{detail.createTime | formatDate('yyyy年MM月dd日')}}</div>
        </div>
      </div>
      <div class="textarea">{{detail.contentText}}</div>
      <div class="img-wrap" >
        <div class="item" v-for="(item, index) in detail.contentImages" :key="index">
          <van-image @click="onImagePreview(detail.contentImages, index)" class="img" :src="item" fit="cover" />
        </div>
      </div>
      <div class="record">
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_fire_01.png')" />
          <span>{{detail.heat}}</span>
        </div>
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_comment_01.png')" />
          <span>{{detail.answer}}</span>
        </div>
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_star_01.png')" />
          <span>{{detail.followers}}</span>
        </div>
      </div>
    </div>
    <div class="comments">
      <Empty
        v-if="answerDetail.totalCount === 0"
        tip="暂无回答！"
      />
      <van-List
        v-else
        v-model="answerDetail.loading"
        :finished="answerDetail.finished"
        @load="onLoad"
      >
        <ul class="list">
          <router-link
            v-for="item in answerDetail.list"
            :to="{name: 'AnswerDetail', query: {id:item.id}}"
            :key="item.id"
            tag="li"
            class="list-item">
            <IssueDetailItem :detail="item"/>
          </router-link>
        </ul>

        <template #finished>
          <van-divider class="list-bottom-tip">滑到底啦</van-divider>
        </template>
      </van-List>
    </div>
    <div class="footer-wrap iphoneX">
      <div class="footer">
        <div class="box">
          <div class="operation" @click="onFollow">
            <template v-if="detail.followStatus">
              <i class="icon icon-star-2"></i>
              <span>已关注</span>
            </template>
            <template v-else>
              <i class="icon icon-star-1"></i>
              <span>关注</span>
            </template>
          </div>
          <button class="btn" @click="$router.push({name:'WriteAnswer', params: {id}})">写回答</button>
        </div>
        <div class="iphoneX"></div>
      </div>
    </div>
  </div>
</template>

<script>
import IssueDetailItem from './components/IssueDetailItem';
import imagePreview from '@/mixins/imagePreview.js';
export default {
  name: 'IssueDetail',
  mixins: [imagePreview],
  components: { IssueDetailItem },
  data () {
    return {
      id: '',
      detail: {},
      answerDetail: {
        list: [],
        pageNo: 1,
        pageSize: 10,
        totalCount: '',
        loading: false,
        finished: false
      }
    };
  },
  mounted () {
    let { id } = this.$route.query;
    this.id = id;
    this.getDetail();
  },
  methods: {
    getDetail () {
      let { id, $http, $utils, $router } = this;
      $http.get('community/circle/ask/detail', {
        params: {
          id
        },
        showLoading: true,
        customError: true
      }).then((res) => {
        this.detail = res.data || {};

        this.$wxShare({
          // url: window.href, // 网址，默认使用 window.location.href
          title: this.detail.name, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
          desc: this.detail.contentText || '广东教育出版社', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
          imgUrl: this.detail.user.avatar // 图片, 默认取网页中第一个img标签
        });

      }).catch((res) => {
        $utils.failToast({
          message: id ? res.msg : '没有该提问,页面即将返回！',
          onClose: () => {
            $router.back();
          }
        });
      });
    },
    onLoad () {
      const { answerDetail: detail, id } = this;
      this.$http.get('community/circle/ask/answer/list', {
        params: {
          id,
          pageNo: detail.pageNo,
          pageSize: detail.pageSize
        },
        hideErrorMessage: true
      }).then((res) => {
        let data = res.data || {};
        detail.list.push(...(data.result || []));
        detail.pageNo++;
        detail.totalCount = data.totalCount || 0;
        detail.loading = false;
        detail.finished = !data.isHasNext;
      });
    },
    onFollow () {
      if (this.$goToLogin()) {
        const { detail, id, $http } = this;
        let apiurl = detail.followStatus ? 'community/circle/ask/unFollow' : 'community/circle/ask/follow';
        $http.post(apiurl, { id }).then((res) => {
          this.getDetail();
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
#issueDetailPage {
  position: relative;
  .header {
    margin: 20px auto 0;
    padding: 20px;
    width: 694px;
    background: #F7F8FC;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      font-weight: bold;
      display: flex;
      margin-bottom: 24px;
      .icon {
        width: 34px;
        height: 36px;
        flex-shrink: 0;
        &.icon-wen{
          background-image: url("~@/assets/images/issue/icon_wen_02.png");
        }
      }
      .name {
        margin-left: 12px;
        font-size: 32px;
        line-height: 36px;
        color: #333444;
      }
    }
    .tags {
      display: flex;
      flex-wrap: wrap;
      .item {
        height: 44px;
        background-color: #EEF3FE;
        border-radius: 24px;
        display: flex;
        align-items: center;
        padding-left: 16px;
        padding-right: 16px;
        .icon {
          width: 26px;
          height: 26px;
          flex-shrink: 0;
        }
        span {
          margin-left: 8px;
          font-size: 24px;
          color: #333444;
        }
      }
    }

  }
  .section {
    padding: 40px 26px;
    .user {
      display: flex;
      .avatar {
        width: 80px;
        height: 80px;
      }
      .info {
        flex: 1;
        width: 0;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .name {
          font-size: 28px;
          color: #333333;
        }
        .date {
          flex-shrink: 0;
          font-size: 24px;
          color: #999AAA;
        }
      }
    }
    .textarea {
      margin: 30px 0;
      font-size: 28px;
      color: #333444;
    }
    .img-wrap {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .item {
        margin-bottom: 20px;
        width: 33.3%;
        display: flex;
        align-items: center;
        justify-content: center;
        .img {
          width: 218px;
          height: 166px;
          background-color: @primaryGreyBg;
          border-radius: 8px;
          overflow: hidden;
        }
      }
    }
    .record {
      margin-top: 20px;
      display: flex;
      align-items: center;
      .item {
        margin-right: 48px;
        display: flex;
        align-items: center;
        .icon {
          width: 32px;
          height: 32px;
        }
        span {
          margin-left: 8px;
          font-size: 24px;
          color: #999AAA;
        }
      }
    }
  }
  .comments {
    padding: 20px 28px;
    background-color: #F7F8FA;
    .list{
      .list-item{
        &:not(:last-child){
          margin-bottom: 20px;
        }
      }
    }

  }
  .footer-wrap {
    padding-top: 100px;
    .footer {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 999;
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.04);
      background-color: #fff;
      .box {
        height: 100px;

        padding-right: 28px;
        padding-left: 28px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .operation {
          width: 4em;
          color: #333444;
          font-size: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .icon {
            width: 32px;
            height: 32px;
            &.icon-star-1{
              background-image: url("~@/assets/images/issue/icon_star_01.png");

            }
            &.icon-star-2{
              background-image: url("~@/assets/images/issue/icon_star_02.png");
            }
          }
          .name {
            line-height: 28px;
            margin-top: 4px;
          }
        }
        .btn {
          width: 450px;
          height: 76px;
          font-size: 26px;
          color: #fff;
          background-image: linear-gradient(90deg, #76DF8A 0%, #42D9A1 43%, #35D092 100%);
          box-shadow: 0px 6px 20px rgba(79, 157, 255, 0.2);
          border-radius: 44px;
        }
      }
    }
  }
}
</style>